import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Message, FileUpload } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../../service/account/account.service';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { PagesComponent } from '../../pages.component';
import { config } from '../../../../../../environments/config';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { User } from '../../../class/user';
import { Employee } from '../../../class/employee';
import { formatDate } from '../../../../../theme/functions/formatDate.function';



@Component({
  selector: 'app-employee-edit-component',
  templateUrl: './employee-edit-component.component.html',
  styleUrls: ['./employee-edit-component.component.scss']
})
export class EmployeeEditComponentComponent implements OnInit {
    public user: User;
    public edit = false;
    public editPass = false;
    public userEdit: User;
    public form: FormGroup;
    public email: AbstractControl;
    public language: AbstractControl;
    public current_password: AbstractControl;
    public password: AbstractControl;
    public confirmPassword: AbstractControl;
    public msgs: Message[] = [];
    public apiUrl = config.API_ROOT;
    public uploadedAvatar: any[] = [];
    public prewiewAvatar: any;
    public defaultAvatar: any;
    public avatar: any;
    public promiseSubmit: Promise<any>;
    public promiseAvatar: Promise<any>;
    public promisePass: Promise<any>;
    public langs= [
            {
                label: 'English', abr: 'en',
            },
            {
                label: 'Español', abr: 'es',
            },
        ];

    public employee: Employee;
    public fieldTextType: Boolean= false;
    public fieldTextType2: Boolean= false;
    public fieldTextType3: Boolean= false;
  constructor(
    fb: FormBuilder,
    public accountService: AccountService,
    public uploadFilesService: UploadFilesService,
    public translate: TranslateService,
    public pagesComponent: PagesComponent,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    this.form = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'email': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'language': [],
    });
    this.email = this.form.controls['email'];
    this.language = this.form.controls['language'];


    // this.defaultAvatar = require('../../../../../../assets/images/avatar.png');
    this.getProfile();
    this.getProfilePermissions();
  }

  ngOnInit() {
  }

  public onUpload(event: any) {
    this.uploadedAvatar = [];
    for (const file of event.srcElement.files) {
        this.uploadedAvatar.push(file);
    }
    if (event.target.files && event.target.files[0]) {
        const reader = new FileReader();
        reader.onload = () => {
          this.prewiewAvatar = reader.result;
        };
        reader.readAsDataURL(event.target.files[0]);
    }
  }
  public updateProfile(values) {
    event.preventDefault();
    this.promiseSubmit = this.accountService.updateProfile(values).toPromise().then(
        response => {
            this.translate.get('saved').subscribe((res: string) => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: res  } );
            });
            this.getProfile();
            // this.pagesComponent.getAccount();
        },
        error => {
            let errorMsg = '';
            errorMsg = 'Error';
            this.msgs = [];
            this.msgs.push( { severity: 'error', summary: errorMsg  } );
        }
    );

  }

  public closeEditPass() {
    console.log('cancelEmployee');
    this.editPass = false;
    this._router.navigate(['pages/account']);
  }
  public getProfile() {
    this.accountService.getAccount().toPromise().then(
        response => {
            this.user = response.json();
            this.employee = this.user.employee;
            this.avatar = (this.user.avatar) ? this.user.avatar : this.defaultAvatar;
            this.edit = true;
            this.email.setValue(this.user.email);
            this.language.setValue(this.user.language);
            this.userEdit = this.user;
            // this.getAvatar();
        },
        error => {
            console.log(error.json());
        }
    );
  }

  public getProfilePermissions() {
    this.accountService.getAccountPermissions().toPromise().then(
        response => {
            this.user.permissions = response.json();
        },
        error => {
            console.log(error.json());
        }
    );
  }
  public cancelEmployee() {
    // this.edit = false
    this._router.navigate(['pages/account']);
    this.getProfile();
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/account/employee-edit-component/employee-edit-component.component.ts